export default __webpack_public_path__ + "static/enterprise-3e192ba7d7708a1fd97c080a7b7940eb.jpg";